import api from "./axiosConfig";
import { ApiResponse, UpdateUserProfilePayload, UserProfile } from "./types";

const BASE_PATH = "portal/";

const userService = {
  getProfile: async () => {
    const response = await api.get<UserProfile>(`${BASE_PATH}accounts/profile`);
    return response.data;
  },

  updateProfile: async (payload: Partial<UpdateUserProfilePayload>) => {
    const response = await api.put<UserProfile>(
      `${BASE_PATH}accounts`,
      payload
    );
    return response.data;
  },

  getPointsBalance: async () => {
    const response = await api.get<ApiResponse<{ points: number }>>(
      "/user/points"
    );
    return response.data;
  },
};

export default userService;
